import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../../firebase';
import {
  collection,
  getDocs,
  getDoc,
  updateDoc,
  doc,
  query,
  where,
  writeBatch,
  addDoc,
  setDoc,
} from 'firebase/firestore';
import { updateEloFromMatch } from '../services/eloService';

const EloAdminPanel = () => {
  const { tournamentId } = useParams();
  const [matches, setMatches] = useState([]);
  const [eloByPhone, setEloByPhone] = useState({});
  const [eloDeltasByMatch, setEloDeltasByMatch] = useState({});
  const [selectedMatches, setSelectedMatches] = useState({});
  const [winnerTeam, setWinnerTeam] = useState('');
  const [winnerPhone1, setWinnerPhone1] = useState('');
  const [winnerPhone2, setWinnerPhone2] = useState('');
  const [savedWinner, setSavedWinner] = useState(null);


  useEffect(() => {
    const fetchMatchesAndPlayers = async () => {
      const allMatches = [];
      const paths = ['matches', 'matches_finales', 'matches_consolation'];
      const phoneSet = new Set();

      for (const path of paths) {
        const snap = await getDocs(collection(db, `tournaments/${tournamentId}/${path}`));
        snap.forEach(docSnap => {
          const match = {
            ...docSnap.data(),
            id: docSnap.id,
            path,
            teamA: docSnap.data().teamA || { name: '', score: 0 },
            teamB: docSnap.data().teamB || { name: '', score: 0 },
            teamAPlayers: docSnap.data().teamAPlayers || [],
            teamBPlayers: docSnap.data().teamBPlayers || [],
            eloUpdated: docSnap.data().eloUpdated || false, // ✅ AJOUTE ÇA

          };
          allMatches.push(match);
          [...match.teamAPlayers, ...match.teamBPlayers].forEach(p => p.phone && phoneSet.add(p.phone.trim()));
        });
      }

      const phoneToElo = {};
      for (const phone of phoneSet) {
        console.log("Recherche joueur avec phone:", phone);

        const q = query(collection(db, 'joueurs'), where('phone', '==', phone));
        const snap = await getDocs(q);
        if (!snap.empty) {
          phoneToElo[phone] = snap.docs[0].data().elo ?? 700;
        }
      }
      
allMatches.sort((a, b) => {
  const phasePriority = {
    matches: 0,
    matches_finales: 1,
    matches_consolation: 2,
  };

  const phaseA = phasePriority[a.path] ?? 99;
  const phaseB = phasePriority[b.path] ?? 99;

  if (phaseA !== phaseB) return phaseA - phaseB;

  return (a.order ?? 0) - (b.order ?? 0);
});
console.log("Liste brute des joueurs pour debug:");

allMatches.forEach((match) => {
  [...(match.teamAPlayers || []), ...(match.teamBPlayers || [])].forEach((player) => {
    console.log(player.prenom, player.nom, player.phone);
  });
});

      setMatches(allMatches);
      // 🔥 Correction manuelle pour William Gathy
phoneToElo["0475205663"] = 898; // Tu mets ici son ELO actuel

      setEloByPhone(phoneToElo);
    };

    fetchMatchesAndPlayers();
  }, [tournamentId]);

  const handleForceEloUpdate = async (match) => {
    try {
      const deltas = await updateEloFromMatch(match, tournamentId, true);


      setEloDeltasByMatch(prev => ({ ...prev, [match.id]: deltas }));
      setEloByPhone(prev => {
        const updated = { ...prev };
        for (const phone in deltas) {
          if (typeof deltas[phone] === 'number') {
            updated[phone] = (updated[phone] ?? 700) + deltas[phone];
          }
        }
        return updated;
      });
      
      alert(`✅ ELO mis à jour pour ${match.teamA.name} vs ${match.teamB.name}`);
    } catch (err) {
      console.error("Erreur ELO forcée:", err);
    }
  };

  const handleResetAllPlayers = async () => {
    try {
      const joueursSnap = await getDocs(collection(db, 'joueurs'));
  
      const batch = writeBatch(db);
  
      joueursSnap.forEach((docSnap) => {
        const joueurRef = doc(db, 'joueurs', docSnap.id);
        batch.update(joueurRef, { elo: 700, matchCount: 0 });
      });
  
      await batch.commit();
      alert('✅ Tous les joueurs ont été remis à 700 ELO et 0 match');
    } catch (err) {
      console.error("Erreur lors de la remise à zéro des joueurs:", err);
    }
  };
  
  const handleResetEloFlag = async (match) => {
    try {
      const ref = doc(db, `tournaments/${tournamentId}/${match.path}/${match.id}`);
      await updateDoc(ref, { eloUpdated: false });
      alert(`♻️ Flag eloUpdated réinitialisé pour ${match.teamA.name} vs ${match.teamB.name}`);
    } catch (err) {
      console.error("Erreur reset eloUpdated:", err);
    }
  };

  const handleUpdateAllElo = async () => {
    const updated = [];
  
    for (const match of matches) {
      const isPlayed =
        (match.teamA?.score ?? 0) > 0 || (match.teamB?.score ?? 0) > 0;
  
      if (!isPlayed || match.eloUpdated === true) continue;
  
      try {
        const deltas = await updateEloFromMatch(match, tournamentId, true);
        updated.push(match.id);
        setEloDeltasByMatch(prev => ({ ...prev, [match.id]: deltas }));
        setEloByPhone(prev => {
          const updated = { ...prev };
          for (const phone in deltas) {
            if (typeof deltas[phone] === 'number') {
              updated[phone] = (updated[phone] ?? 700) + deltas[phone];
            }
          }
          return updated;
        });
        
      } catch (err) {
        console.error(`Erreur sur match ${match.teamA.name} vs ${match.teamB.name}`, err);
      }
    }
  
    alert(`✅ ${updated.length} match(s) ont été mis à jour.`);
  };
  
  const handleUpdateSelectedElo = async () => {
    const updated = [];
  
    for (const match of matches) {
      const isPlayed = (match.teamA?.score ?? 0) > 0 || (match.teamB?.score ?? 0) > 0;
  
      if (!isPlayed || match.eloUpdated === true || !selectedMatches[match.id]) continue;
  
      try {
        const deltas = await updateEloFromMatch(match, tournamentId, true);
        updated.push(match.id);
        setEloDeltasByMatch((prev) => ({ ...prev, [match.id]: deltas }));
        setEloByPhone(prev => {
          const updated = { ...prev };
          for (const phone in deltas) {
            if (typeof deltas[phone] === 'number') {
              updated[phone] = (updated[phone] ?? 700) + deltas[phone];
            }
          }
          return updated;
        });
        
      } catch (err) {
        console.error(`Erreur sur match ${match.teamA.name} vs ${match.teamB.name}`, err);
      }
    }
  
    alert(`✅ ${updated.length} match(s) sélectionné(s) ont été mis à jour.`);
  };

  const findWinningTeamWithPlayers = () => {
    const phone1 = cleanPhone(winnerPhone1);
    const phone2 = cleanPhone(winnerPhone2);
  
    if (!phone1 || !phone2) return null;
  
    for (const match of matches) {
      const teamAPlayers = match.teamAPlayers || [];
      const teamBPlayers = match.teamBPlayers || [];
  
      const teamAPhones = teamAPlayers.map((p) => cleanPhone(p.phone));
      const teamBPhones = teamBPlayers.map((p) => cleanPhone(p.phone));
  
      const bothInTeamA = teamAPhones.includes(phone1) && teamAPhones.includes(phone2);
      const bothInTeamB = teamBPhones.includes(phone1) && teamBPhones.includes(phone2);
  
      if (bothInTeamA) {
        return {
          teamName: match.teamA.name,
          players: teamAPlayers.map((p) => ({
            prenom: p.prenom || '',
            nom: p.nom || '',
            phone: cleanPhone(p.phone),
          })),
        };
      }
  
      if (bothInTeamB) {
        return {
          teamName: match.teamB.name,
          players: teamBPlayers.map((p) => ({
            prenom: p.prenom || '',
            nom: p.nom || '',
            phone: cleanPhone(p.phone),
          })),
        };
      }
    }
  
    return null;
  };

  const cleanPhone = (phone) =>
  phone?.toString().replace(/\s+/g, '').trim() || '';

const findPlayerByPhone = (phone) => {
  const cleanedPhone = cleanPhone(phone);

  if (!cleanedPhone) return null;

  for (const match of matches) {
    const allPlayers = [
      ...(match.teamAPlayers || []),
      ...(match.teamBPlayers || []),
    ];

    const foundPlayer = allPlayers.find(
      (player) => cleanPhone(player.phone) === cleanedPhone
    );

    if (foundPlayer) {
      return {
        prenom: foundPlayer.prenom || '',
        nom: foundPlayer.nom || '',
        phone: cleanPhone(foundPlayer.phone),
      };
    }
  }

  return null;
};

const winnerPreview = useMemo(() => {
  const phone1 = cleanPhone(winnerPhone1);
  const phone2 = cleanPhone(winnerPhone2);

  const player1 = findPlayerByPhone(phone1);
  const player2 = findPlayerByPhone(phone2);

  if (!phone1 && !phone2) {
    return {
      status: 'empty',
      message: 'Encode les deux numéros des joueurs gagnants.',
      player1,
      player2,
      team: null,
    };
  }

  if (!phone1 || !phone2) {
    return {
      status: 'missing',
      message: 'Il manque encore un numéro de téléphone.',
      player1,
      player2,
      team: null,
    };
  }

  if (!player1 || !player2) {
    return {
      status: 'not_found',
      message: 'Un ou plusieurs joueurs sont introuvables dans ce tournoi.',
      player1,
      player2,
      team: null,
    };
  }

  const team = findWinningTeamWithPlayers();

  if (!team) {
    return {
      status: 'wrong_team',
      message: 'Les deux joueurs existent, mais ils ne semblent pas être dans la même équipe.',
      player1,
      player2,
      team: null,
    };
  }

  return {
    status: 'valid',
    message: 'Équipe gagnante détectée correctement.',
    player1,
    player2,
    team,
  };
}, [winnerPhone1, winnerPhone2, matches]);
  
const handleSaveWinner = async () => {
  try {
    const result = findWinningTeamWithPlayers();

    if (!result) {
      alert("❌ Impossible d'enregistrer : équipe gagnante introuvable ou joueurs pas dans la même équipe.");
      return;
    }

    const winnerRef = doc(db, 'winners', tournamentId);

    const payload = {
      tournamentId,
      teamName: result.teamName,
      players: result.players,
      createdAt: new Date(),
      type: 'tournament_winner',
    };

    await setDoc(winnerRef, payload);

    setWinnerTeam(result.teamName);
    setSavedWinner(payload);

    alert(`🏆 ${result.teamName} enregistré comme vainqueur`);
  } catch (err) {
    console.error(err);
    alert("❌ Erreur lors de l'enregistrement du vainqueur");
  }
};

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold text-center text-[#4c2f8e] mb-8">
        🛠 Panneau Admin - Mise à jour du Classement ELO
      </h2>

      <div className="relative overflow-hidden bg-white border border-purple-100 p-6 rounded-3xl shadow-xl mb-8">
  <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-[#f6e7b4] via-[#c6a15b] to-[#8b6a2f]" />
  <div className="absolute -top-20 -right-20 h-44 w-44 rounded-full bg-[#4c2f8e]/10 blur-3xl pointer-events-none" />
  <div className="absolute -bottom-24 left-16 h-44 w-44 rounded-full bg-[#c6a15b]/10 blur-3xl pointer-events-none" />

  <div className="relative z-10">
    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
      <div>
        <p className="text-[10px] font-black uppercase tracking-[0.30em] text-[#8b6a2f]">
          Gestion du vainqueur
        </p>

        <h3 className="text-2xl font-black text-[#4c2f8e] mt-1">
          🏆 Enregistrer le vainqueur du tournoi
        </h3>

        <p className="text-sm text-gray-500 mt-2">
          Encode les deux numéros de téléphone. Le système détecte automatiquement l’équipe et les joueurs associés.
        </p>
      </div>

      <div
        className={`rounded-full px-4 py-2 text-xs font-black uppercase tracking-wider border ${
          winnerPreview.status === 'valid'
            ? 'bg-green-50 text-green-700 border-green-200'
            : winnerPreview.status === 'empty'
            ? 'bg-gray-50 text-gray-500 border-gray-200'
            : 'bg-red-50 text-red-700 border-red-200'
        }`}
      >
        {winnerPreview.status === 'valid' ? 'Équipe validée' : 'À vérifier'}
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
      <div>
        <label className="block text-sm font-bold text-gray-700 mb-2">
          Téléphone joueur gagnant 1
        </label>

        <input
          type="text"
          value={winnerPhone1}
          onChange={(e) => setWinnerPhone1(e.target.value)}
          placeholder="Ex : 0475..."
          className="w-full border border-gray-200 rounded-2xl px-4 py-3 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
        />

        <div className="mt-2 min-h-[24px]">
          {winnerPreview.player1 ? (
            <div className="inline-flex items-center gap-2 rounded-full bg-green-50 border border-green-200 px-3 py-1 text-xs font-bold text-green-700">
              ✅ {winnerPreview.player1.prenom} {winnerPreview.player1.nom}
            </div>
          ) : cleanPhone(winnerPhone1) ? (
            <div className="inline-flex items-center gap-2 rounded-full bg-red-50 border border-red-200 px-3 py-1 text-xs font-bold text-red-700">
              ❌ Joueur introuvable
            </div>
          ) : (
            <div className="text-xs text-gray-400">
              En attente du numéro...
            </div>
          )}
        </div>
      </div>

      <div>
        <label className="block text-sm font-bold text-gray-700 mb-2">
          Téléphone joueur gagnant 2
        </label>

        <input
          type="text"
          value={winnerPhone2}
          onChange={(e) => setWinnerPhone2(e.target.value)}
          placeholder="Ex : 0498..."
          className="w-full border border-gray-200 rounded-2xl px-4 py-3 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
        />

        <div className="mt-2 min-h-[24px]">
          {winnerPreview.player2 ? (
            <div className="inline-flex items-center gap-2 rounded-full bg-green-50 border border-green-200 px-3 py-1 text-xs font-bold text-green-700">
              ✅ {winnerPreview.player2.prenom} {winnerPreview.player2.nom}
            </div>
          ) : cleanPhone(winnerPhone2) ? (
            <div className="inline-flex items-center gap-2 rounded-full bg-red-50 border border-red-200 px-3 py-1 text-xs font-bold text-red-700">
              ❌ Joueur introuvable
            </div>
          ) : (
            <div className="text-xs text-gray-400">
              En attente du numéro...
            </div>
          )}
        </div>
      </div>
    </div>

    <div
      className={`rounded-2xl border p-4 mb-5 ${
        winnerPreview.status === 'valid'
          ? 'bg-gradient-to-br from-green-50 to-white border-green-200'
          : winnerPreview.status === 'empty'
          ? 'bg-gray-50 border-gray-200'
          : 'bg-red-50 border-red-200'
      }`}
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <p
            className={`text-sm font-bold ${
              winnerPreview.status === 'valid'
                ? 'text-green-700'
                : winnerPreview.status === 'empty'
                ? 'text-gray-500'
                : 'text-red-700'
            }`}
          >
            {winnerPreview.message}
          </p>

          {winnerPreview.team && (
            <div className="mt-2">
              <div className="text-lg font-black text-[#4c2f8e]">
                {winnerPreview.team.teamName}
              </div>

              <div className="mt-2 flex flex-wrap gap-2">
                {winnerPreview.team.players.map((player, index) => (
                  <span
                    key={index}
                    className="rounded-full border border-purple-100 bg-white px-3 py-1 text-xs font-bold text-gray-700 shadow-sm"
                  >
                    {player.prenom} {player.nom}
                    {player.phone ? ` · ${player.phone}` : ''}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <button
          onClick={handleSaveWinner}
          disabled={winnerPreview.status !== 'valid'}
          className={`w-full md:w-auto px-6 py-3 rounded-full font-black shadow-md transition ${
            winnerPreview.status === 'valid'
              ? 'bg-[#4c2f8e] text-white hover:bg-[#3d2575] hover:scale-105'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          🏆 Enregistrer le vainqueur
        </button>
      </div>
    </div>

    {savedWinner && (
      <div className="rounded-2xl border border-[#d8c7a3] bg-gradient-to-br from-[#fffdf8] via-[#f8f3e8] to-[#efe5d0] p-4 shadow-sm">
        <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#8b6a2f]">
          Dernier vainqueur enregistré
        </p>

        <div className="mt-1 text-lg font-black text-[#241c12]">
          🏆 {savedWinner.teamName}
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          {savedWinner.players.map((player, index) => (
            <span
              key={index}
              className="rounded-full border border-[#d8c7a3]/70 bg-white/80 px-3 py-1 text-sm font-bold text-[#4a3820] shadow-sm"
            >
              {player.prenom} {player.nom}
              {player.phone ? ` · ${player.phone}` : ''}
            </span>
          ))}
        </div>
      </div>
    )}
  </div>
</div>

{winnerTeam && (
  <div className="mt-2 text-green-600 font-semibold">
    🏆 Équipe trouvée : {winnerTeam}
  </div>
)}

      <button
  onClick={async () => {
    try {
      const res = await fetch("https://us-central1-mendyx-adafe.cloudfunctions.net/updateTournamentDetails-updateTournamentDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await res.json();

      if (res.ok) {
        alert("✅ Tournois synchronisés avec Firestore !");
        console.log("Synchronisation :", data.message);
      } else {
        console.error("Erreur :", data.error || data);
        alert("❌ Échec de la synchronisation : " + (data.error || "Erreur inconnue"));
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      alert("❌ Erreur réseau lors de la synchronisation.");
    }
  }}
  className="mb-8 px-6 py-2 bg-purple-700 text-white rounded-full shadow hover:bg-purple-800 transition-all block mx-auto"
>
  🔄 Synchroniser les tournois Firestore
</button>

<button
  onClick={async () => {
    try {
      const res = await fetch("https://us-central1-mendyx-adafe.cloudfunctions.net/updateLeagueDetails-updateLeagueDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await res.json();

      if (res.ok) {
        alert("✅ Ligues synchronisés avec Firestore !");
        console.log("Synchronisation :", data.message);
      } else {
        console.error("Erreur :", data.error || data);
        alert("❌ Échec de la synchronisation : " + (data.error || "Erreur inconnue"));
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      alert("❌ Erreur réseau lors de la synchronisation.");
    }
  }}
  className="mb-8 px-6 py-2 bg-purple-700 text-white rounded-full shadow hover:bg-purple-800 transition-all block mx-auto"
>
  🔄 Synchroniser les Ligues Firestore
</button>


      <button
  onClick={handleUpdateAllElo}
  className="mb-6 px-6 py-3 bg-gradient-to-r from-green-500 to-green-700 text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl block mx-auto"
>
  ✅ Mettre à jour tous les ELO
</button>

<button
  onClick={handleUpdateSelectedElo}
  className="mb-6 px-6 py-3 bg-blue-600 text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl block mx-auto"
>
  🧮 Mettre à jour quelques matchs
</button>

<button
  onClick={() => {
    const allSelected = Object.keys(selectedMatches).length === matches.length;
    const newSelection = {};
    if (!allSelected) {
      matches.forEach(m => { newSelection[m.id] = true });
    }
    setSelectedMatches(allSelected ? {} : newSelection);
  }}
  className="mb-6 px-6 py-2 bg-gray-300 text-gray-800 rounded-full shadow hover:bg-gray-400 transition-all block mx-auto"
>
  🎯 {Object.keys(selectedMatches).length === matches.length ? "Tout désélectionner" : "Tout sélectionner"}
</button>




      {matches.length === 0 ? (
        <p className="text-center text-gray-500">Aucun match trouvé pour ce tournoi.</p>
      ) : (
        <ul className="space-y-6">
          {matches.map((match, idx) => (
            <li key={idx} className="p-6 bg-white rounded-lg shadow border">
              <div className="flex items-center space-x-2 mb-2">
  <input
    type="checkbox"
    checked={!!selectedMatches[match.id]}
    onChange={() =>
      setSelectedMatches(prev => ({
        ...prev,
        [match.id]: !prev[match.id],
      }))
    }
  />
  <span className="text-sm text-gray-500">Sélectionner ce match</span>
</div>

              <div className="flex justify-between items-center">
                <div>
                
                  <div className="text-lg font-semibold">
                    {match.teamA.name} vs {match.teamB.name}
                  </div>
                  <div className="text-sm text-gray-600">
                    Score : {match.teamA.score ?? 0} - {match.teamB.score ?? 0}
                  </div>
                  <div className="text-sm mt-1">
                    {match.eloUpdated ? (
                      <span className="text-green-600 font-semibold">ELO mis à jour ✅</span>
                    ) : (
                      <span className="text-red-600 font-semibold">ELO non mis à jour ❌</span>
                    )}
                  </div>

                  {[...(match.teamAPlayers || []), ...(match.teamBPlayers || [])].map((player, i) => {
  const cleanPhone = player.phone?.toString().trim(); // ✅ Nettoyer le téléphone ici
  const elo = eloByPhone[cleanPhone] ?? '...';
  const delta = eloDeltasByMatch[match.id]?.[cleanPhone];
  console.log("Afficher joueur:", player.prenom, player.nom, "phone brut:", player.phone, "clean:", cleanPhone, "elo trouvé:", elo);

                    return (
                      <div key={i} className="text-sm text-gray-700">
{player.prenom} {player.nom} ({cleanPhone}) : ELO {elo}
                        
                      </div>
                    );
                  })}
                </div>

                <div className="flex flex-col space-y-2">
                  <button
                    onClick={() => handleForceEloUpdate(match)}
                    className="px-4 py-1 bg-blue-600 text-white rounded shadow hover:bg-blue-700"
                  >
                    🔁 Forcer mise à jour ELO
                  </button>
                  <button
                    onClick={() => handleResetEloFlag(match)}
                    className="px-4 py-1 bg-yellow-500 text-white rounded shadow hover:bg-yellow-600"
                  >
                    ♻️ Réinitialiser Flag
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EloAdminPanel;